// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FilterPanel layout & responsive rules */

/* Root container for this component */
.filter-panel {
    padding: 5px;
    position: relative;
}

/* Controls row: category, name, address on a single line */
.filter-panel .controls-row {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    flex-wrap: nowrap;
}

/* Make the three main controls share space equally (category, name, address) */
.filter-panel .controls-row > div:nth-child(1),
.filter-panel .controls-row > div:nth-child(2),
.filter-panel .controls-row > div:nth-child(3) {
    flex: 1 1;
    min-width: 0; /* allow inputs to shrink properly inside flex */
}

/* Keep position:relative only on the category column for absolute-positioned dropdown card */
.filter-panel .controls-row > div:first-child {
    position: relative;
}

/* Ensure inputs occupy their container */
.filter-panel .controls-row .form-control {
    width: 100%;
}

/* Make dropdown buttons visually match the small text inputs:
   same height, border color and border thickness as .form-control-sm */
.filter-panel .controls-row .filterCollapseButton,
.filter-panel .points-row .btn {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;

    /* sizing to match .form-control-sm */
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    line-height: 1.5;
    box-sizing: border-box;
    min-height: 36px; /* ensures visual parity with the inputs */

    /* border to match inputs */
    border: 1px solid #ced4da !important;
    border-width: 1px;
    border-radius: 0.25rem;
    background-color: #fff;

    /* remove button default shadow so it looks like an input */
    box-shadow: none !important;
}

/* Focus state similar to form controls */
.filter-panel .controls-row .filterCollapseButton:focus,
.filter-panel .points-row .btn:focus {
    outline: none;
    border-color: #86b7ff !important;
    box-shadow: 0 0 0 0.2rem rgba(13,110,253,0.15) !important;
}

/* Position the category dropdown card so it doesn't disrupt the flex layout */
.filter-panel .controls-row > div:first-child .card {
    position: absolute;
    z-index: 1050;
    top: calc(100% + 0.25rem);
    left: 0;
    width: 100%; /* match the width of the parent control so dropdown aligns with the control */
    max-height: 300px;
    overflow: auto;
    box-shadow: 0 6px 18px rgba(0,0,0,0.08);
}

/* --- New: nicer rounded dropdown card & list styles --- */
/* Rounded card, subtle border and elevation, inner padding */
.filter-panel .controls-row > div:first-child .card {
    border-radius: 10px;
    border: 1px solid rgba(0,0,0,0.06);
    background-color: #ffffff;
    padding: 0.5rem;
    box-shadow: 0 10px 30px rgba(0,0,0,0.08);
    transition: transform 120ms ease, opacity 120ms ease;
    transform-origin: top left;
}

/* Slight pop effect when opened (if preferred by JS toggle you can add a class) */
.filter-panel .controls-row > div:first-child .card.open {
    transform: translateY(0);
    opacity: 1;
}

/* Make the "Select/Deselect all" area visually separated */
.filter-panel .controls-row > div:first-child .card .form-check.mb-2 {
    padding-bottom: 0.45rem;
    margin-bottom: 0.55rem;
    border-bottom: 1px solid rgba(0,0,0,0.04);
}

/* Style category list items for a cleaner touch target */
.filter-panel .card .form-check {
    display: flex;
    align-items: center;
    margin-bottom: 0.35rem;
    position: relative;
    padding: 0.125rem 0.125rem;
    border-radius: 8px;
}

/* Label becomes the visible control */
.filter-panel .card .form-check-label {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    width: 100%;
    padding: 0.25rem 0.35rem;
    border-radius: 6px;
    transition: background-color 120ms ease;
}

/* Hover and focus affordances */
.filter-panel .card .form-check-label:hover {
    background-color: rgba(0,0,0,0.03);
}
.filter-panel .card .form-check-input:focus + .form-check-label {
    background-color: rgba(13,110,253,0.03);
    outline: none;
}

/* Colored swatch acts as the checkbox visual. Color is supplied inline on the element. */
.filter-panel .card .color-swatch {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 4px;
    border: 1px solid #e6e6e6;
    box-sizing: border-box;
    flex-shrink: 0;
}

.filter-panel .card .form-check-input:checked + .form-check-label .color-swatch {
    box-shadow: inset 0 0 0 3px rgba(255,255,255,0.18);
    border-color: rgba(0,0,0,0.06);
}

/* Keep the native input accessible but visually hidden */
.filter-panel .card .form-check-input {
    position: absolute;
    opacity: 0;
    width: 1px;
    height: 1px;
    margin: 0;
    clip: rect(1px, 1px, 1px, 1px);
    clip-path: inset(50%);
    overflow: hidden;
}

/* Focus ring on the swatch when the hidden input is focused */
.filter-panel .card .form-check-input:focus + .form-check-label .color-swatch {
    box-shadow: 0 0 0 4px rgba(13,110,253,0.10);
}

/* Disabled state */
.filter-panel .card .form-check-input:disabled + .form-check-label {
    opacity: 0.6;
    cursor: default;
}

/* Subtle divider at the bottom when content is long */
.filter-panel .controls-row > div:first-child .card::after {
    content: "";
    display: block;
    height: 6px;
    pointer-events: none;
}

/* Custom scrollbar (modern browsers) */
.filter-panel .controls-row > div:first-child .card::-webkit-scrollbar {
    width: 8px;
}
.filter-panel .controls-row > div:first-child .card::-webkit-scrollbar-thumb {
    background: rgba(0,0,0,0.08);
    border-radius: 8px;
}
.filter-panel .controls-row > div:first-child .card::-webkit-scrollbar-track {
    background: transparent;
}

/* Points row sits on its own line and its child takes full width */
.filter-panel .points-row {
    margin-top: 0.5rem;
}
.filter-panel .points-row > div {
    width: 100%;
}

/* Ensure category dropdown button text is left-aligned while keeping the caret at the right */
.filter-panel .controls-row > div:first-child .filterCollapseButton {
    justify-content: flex-start;
    text-align: left;
}

.filter-panel .controls-row > div:first-child .filterCollapseButton > *:last-child {
    margin-left: auto;
}

/* Prevent the category button content from wrapping and show ellipses */
.filter-panel .controls-row > div:first-child .filterCollapseButton > div {
    flex: 1 1;
    min-width: 0;              /* allow flex child to shrink */
    overflow: hidden;
    white-space: nowrap;       /* prevent wrapping */
    text-overflow: ellipsis;   /* show "..." when truncated */
    display: block;
    text-align: left;
}

/* Ensure the caret stays pinned to the right and doesn't get pushed or centered */
.filter-panel .controls-row > div:first-child .filterCollapseButton > *:last-child {
    margin-left: auto;
    flex: 0 0 auto;
}

/* Ensure dropdown list items remain left-aligned when their label text wraps */
.filter-panel .card .form-check-label {
    display: inline-flex;
    justify-content: flex-start; /* keep swatch + text left-aligned */
    align-items: center;
    text-align: left;
}

/* Allow the label text to wrap if needed but keep it left-aligned and ensure it can shrink */
.filter-panel .card .form-check-label > span:last-child {
    flex: 1 1;
    min-width: 0;
    white-space: normal;         /* allow wrapping inside list item */
    overflow-wrap: anywhere;     /* safer breaks for long words/URLs */
    word-break: break-word;
    text-align: left;
}

/* Give the swatch a small right gap so wrapped text doesn't touch it */
.filter-panel .card .color-swatch {
    margin-right: 0.5rem;
}

/* Responsive: stack controls on narrow screens */
@media (max-width: 576px) {
    .filter-panel .controls-row {
        flex-wrap: wrap;
        gap: 0.5rem;
    }

    .filter-panel .controls-row > div:first-child,
    .filter-panel .controls-row > div:nth-child(2),
    .filter-panel .controls-row > div:nth-child(3) {
        flex: 1 1 100%;
    }

    .filter-panel .controls-row > div:first-child .card {
        width: 100%;
        left: 0;
        top: calc(100% + 0.25rem);
    }
}

/* Visible points list entry styles: colored swatch, left-aligned text, emphasized name */
.filter-panel .points-row .card {
    padding: 0.5rem;
    max-height: 300px;
    overflow: auto;
}

/* Each entry row */
.filter-panel .points-row .card > div {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.4rem 0.45rem;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 120ms ease;
}

/* Hover / active affordance */
.filter-panel .points-row .card > div:hover {
    background-color: rgba(0,0,0,0.03);
}

/* Left color swatch (the first span in each entry) */
.filter-panel .points-row .card > div > span:first-child {
    width: 14px;
    height: 14px;
    border-radius: 4px;
    border: 1px solid #e6e6e6;
    flex: 0 0 14px;
    box-sizing: border-box;
}

/* Text container: ensure it can shrink and keep text left-aligned */
.filter-panel .points-row .card > div > div {
    min-width: 0;
    width: 100%;
    overflow: hidden;
}

/* Inner text layout: place name and address on the same row */
.filter-panel .points-row .card > div > div > div {
    display: flex;
    flex-direction: row;        /* place name + address on one line */
    align-items: center;
    gap: 0.5rem;
    min-width: 0;
}

/* Emphasized name: bold, keep its natural width, truncate if too long */
.filter-panel .points-row .card > div > div > div > span:first-child {
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    flex: 0 0 auto;            /* don't let the name collapse; keep intrinsic size */
    max-width: 40%;            /* prevent name from taking all space (tweak as needed) */
    text-align: left;
}

/* Address / secondary text: take remaining space, left-aligned and truncated */
.filter-panel .points-row .card > div > div > div > span:last-child {
    color: #6c757d;
    font-size: 0.9rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    flex: 1 1;               /* fill remaining space and truncate */
    min-width: 0;              /* allow truncation inside flex */
    text-align: left;
}

/* Make sure overall card entries remain left_aligned on small screens too */
@media (max-width: 576px) {
    .filter-panel .points-row .card > div > div > div > span:first-child,
    .filter-panel .points-row .card > div > div > div > span:last-child {
        white-space: nowrap;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/css/FilterPanel.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C,sCAAsC;AACtC;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA,2DAA2D;AAC3D;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,+EAA+E;AAC/E;;;IAGI,SAAY;IACZ,YAAY,EAAE,gDAAgD;AAClE;;AAEA,6FAA6F;AAC7F;IACI,kBAAkB;AACtB;;AAEA,yCAAyC;AACzC;IACI,WAAW;AACf;;AAEA;uEACuE;AACvE;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;;IAEX,qCAAqC;IACrC,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB,EAAE,0CAA0C;;IAE5D,2BAA2B;IAC3B,oCAAoC;IACpC,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;;IAEtB,2DAA2D;IAC3D,2BAA2B;AAC/B;;AAEA,yCAAyC;AACzC;;IAEI,aAAa;IACb,gCAAgC;IAChC,yDAAyD;AAC7D;;AAEA,8EAA8E;AAC9E;IACI,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,OAAO;IACP,WAAW,EAAE,8EAA8E;IAC3F,iBAAiB;IACjB,cAAc;IACd,uCAAuC;AAC3C;;AAEA,2DAA2D;AAC3D,6DAA6D;AAC7D;IACI,mBAAmB;IACnB,kCAAkC;IAClC,yBAAyB;IACzB,eAAe;IACf,wCAAwC;IACxC,oDAAoD;IACpD,0BAA0B;AAC9B;;AAEA,kFAAkF;AAClF;IACI,wBAAwB;IACxB,UAAU;AACd;;AAEA,2DAA2D;AAC3D;IACI,uBAAuB;IACvB,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA,sCAAsC;AACtC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA,gCAAgC;AAChC;IACI,kCAAkC;AACtC;AACA;IACI,uCAAuC;IACvC,aAAa;AACjB;;AAEA,yFAAyF;AACzF;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,kDAAkD;IAClD,8BAA8B;AAClC;;AAEA,yDAAyD;AACzD;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;IACX,SAAS;IACT,8BAA8B;IAC9B,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,8DAA8D;AAC9D;IACI,2CAA2C;AAC/C;;AAEA,mBAAmB;AACnB;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA,sDAAsD;AACtD;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,oBAAoB;AACxB;;AAEA,uCAAuC;AACvC;IACI,UAAU;AACd;AACA;IACI,4BAA4B;IAC5B,kBAAkB;AACtB;AACA;IACI,uBAAuB;AAC3B;;AAEA,mEAAmE;AACnE;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;;AAEA,8FAA8F;AAC9F;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,wEAAwE;AACxE;IACI,SAAW;IACX,YAAY,eAAe,+BAA+B;IAC1D,gBAAgB;IAChB,mBAAmB,QAAQ,qBAAqB;IAChD,uBAAuB,IAAI,8BAA8B;IACzD,cAAc;IACd,gBAAgB;AACpB;;AAEA,kFAAkF;AAClF;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA,+EAA+E;AAC/E;IACI,oBAAoB;IACpB,2BAA2B,EAAE,oCAAoC;IACjE,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,6FAA6F;AAC7F;IACI,SAAW;IACX,YAAY;IACZ,mBAAmB,UAAU,oCAAoC;IACjE,uBAAuB,MAAM,qCAAqC;IAClE,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,uEAAuE;AACvE;IACI,oBAAoB;AACxB;;AAEA,iDAAiD;AACjD;IACI;QACI,eAAe;QACf,WAAW;IACf;;IAEA;;;QAGI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,OAAO;QACP,yBAAyB;IAC7B;AACJ;;AAEA,yFAAyF;AACzF;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,uCAAuC;AAC3C;;AAEA,8BAA8B;AAC9B;IACI,kCAAkC;AACtC;;AAEA,qDAAqD;AACrD;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,sBAAsB;AAC1B;;AAEA,oEAAoE;AACpE;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA,8DAA8D;AAC9D;IACI,aAAa;IACb,mBAAmB,SAAS,qCAAqC;IACjE,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA,wEAAwE;AACxE;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,cAAc,aAAa,qDAAqD;IAChF,cAAc,aAAa,yDAAyD;IACpF,gBAAgB;AACpB;;AAEA,+EAA+E;AAC/E;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,SAAW,gBAAgB,sCAAsC;IACjE,YAAY,eAAe,iCAAiC;IAC5D,gBAAgB;AACpB;;AAEA,4EAA4E;AAC5E;IACI;;QAEI,mBAAmB;IACvB;AACJ","sourcesContent":["/* FilterPanel layout & responsive rules */\r\n\r\n/* Root container for this component */\r\n.filter-panel {\r\n    padding: 5px;\r\n    position: relative;\r\n}\r\n\r\n/* Controls row: category, name, address on a single line */\r\n.filter-panel .controls-row {\r\n    display: flex;\r\n    gap: 0.5rem;\r\n    align-items: center;\r\n    flex-wrap: nowrap;\r\n}\r\n\r\n/* Make the three main controls share space equally (category, name, address) */\r\n.filter-panel .controls-row > div:nth-child(1),\r\n.filter-panel .controls-row > div:nth-child(2),\r\n.filter-panel .controls-row > div:nth-child(3) {\r\n    flex: 1 1 0%;\r\n    min-width: 0; /* allow inputs to shrink properly inside flex */\r\n}\r\n\r\n/* Keep position:relative only on the category column for absolute-positioned dropdown card */\r\n.filter-panel .controls-row > div:first-child {\r\n    position: relative;\r\n}\r\n\r\n/* Ensure inputs occupy their container */\r\n.filter-panel .controls-row .form-control {\r\n    width: 100%;\r\n}\r\n\r\n/* Make dropdown buttons visually match the small text inputs:\r\n   same height, border color and border thickness as .form-control-sm */\r\n.filter-panel .controls-row .filterCollapseButton,\r\n.filter-panel .points-row .btn {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 0.5rem;\r\n\r\n    /* sizing to match .form-control-sm */\r\n    width: 100%;\r\n    padding: 0.375rem 0.75rem;\r\n    font-size: 0.875rem;\r\n    line-height: 1.5;\r\n    box-sizing: border-box;\r\n    min-height: 36px; /* ensures visual parity with the inputs */\r\n\r\n    /* border to match inputs */\r\n    border: 1px solid #ced4da !important;\r\n    border-width: 1px;\r\n    border-radius: 0.25rem;\r\n    background-color: #fff;\r\n\r\n    /* remove button default shadow so it looks like an input */\r\n    box-shadow: none !important;\r\n}\r\n\r\n/* Focus state similar to form controls */\r\n.filter-panel .controls-row .filterCollapseButton:focus,\r\n.filter-panel .points-row .btn:focus {\r\n    outline: none;\r\n    border-color: #86b7ff !important;\r\n    box-shadow: 0 0 0 0.2rem rgba(13,110,253,0.15) !important;\r\n}\r\n\r\n/* Position the category dropdown card so it doesn't disrupt the flex layout */\r\n.filter-panel .controls-row > div:first-child .card {\r\n    position: absolute;\r\n    z-index: 1050;\r\n    top: calc(100% + 0.25rem);\r\n    left: 0;\r\n    width: 100%; /* match the width of the parent control so dropdown aligns with the control */\r\n    max-height: 300px;\r\n    overflow: auto;\r\n    box-shadow: 0 6px 18px rgba(0,0,0,0.08);\r\n}\r\n\r\n/* --- New: nicer rounded dropdown card & list styles --- */\r\n/* Rounded card, subtle border and elevation, inner padding */\r\n.filter-panel .controls-row > div:first-child .card {\r\n    border-radius: 10px;\r\n    border: 1px solid rgba(0,0,0,0.06);\r\n    background-color: #ffffff;\r\n    padding: 0.5rem;\r\n    box-shadow: 0 10px 30px rgba(0,0,0,0.08);\r\n    transition: transform 120ms ease, opacity 120ms ease;\r\n    transform-origin: top left;\r\n}\r\n\r\n/* Slight pop effect when opened (if preferred by JS toggle you can add a class) */\r\n.filter-panel .controls-row > div:first-child .card.open {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n}\r\n\r\n/* Make the \"Select/Deselect all\" area visually separated */\r\n.filter-panel .controls-row > div:first-child .card .form-check.mb-2 {\r\n    padding-bottom: 0.45rem;\r\n    margin-bottom: 0.55rem;\r\n    border-bottom: 1px solid rgba(0,0,0,0.04);\r\n}\r\n\r\n/* Style category list items for a cleaner touch target */\r\n.filter-panel .card .form-check {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 0.35rem;\r\n    position: relative;\r\n    padding: 0.125rem 0.125rem;\r\n    border-radius: 8px;\r\n}\r\n\r\n/* Label becomes the visible control */\r\n.filter-panel .card .form-check-label {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    cursor: pointer;\r\n    user-select: none;\r\n    width: 100%;\r\n    padding: 0.25rem 0.35rem;\r\n    border-radius: 6px;\r\n    transition: background-color 120ms ease;\r\n}\r\n\r\n/* Hover and focus affordances */\r\n.filter-panel .card .form-check-label:hover {\r\n    background-color: rgba(0,0,0,0.03);\r\n}\r\n.filter-panel .card .form-check-input:focus + .form-check-label {\r\n    background-color: rgba(13,110,253,0.03);\r\n    outline: none;\r\n}\r\n\r\n/* Colored swatch acts as the checkbox visual. Color is supplied inline on the element. */\r\n.filter-panel .card .color-swatch {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 18px;\r\n    height: 18px;\r\n    border-radius: 4px;\r\n    border: 1px solid #e6e6e6;\r\n    box-sizing: border-box;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.filter-panel .card .form-check-input:checked + .form-check-label .color-swatch {\r\n    box-shadow: inset 0 0 0 3px rgba(255,255,255,0.18);\r\n    border-color: rgba(0,0,0,0.06);\r\n}\r\n\r\n/* Keep the native input accessible but visually hidden */\r\n.filter-panel .card .form-check-input {\r\n    position: absolute;\r\n    opacity: 0;\r\n    width: 1px;\r\n    height: 1px;\r\n    margin: 0;\r\n    clip: rect(1px, 1px, 1px, 1px);\r\n    clip-path: inset(50%);\r\n    overflow: hidden;\r\n}\r\n\r\n/* Focus ring on the swatch when the hidden input is focused */\r\n.filter-panel .card .form-check-input:focus + .form-check-label .color-swatch {\r\n    box-shadow: 0 0 0 4px rgba(13,110,253,0.10);\r\n}\r\n\r\n/* Disabled state */\r\n.filter-panel .card .form-check-input:disabled + .form-check-label {\r\n    opacity: 0.6;\r\n    cursor: default;\r\n}\r\n\r\n/* Subtle divider at the bottom when content is long */\r\n.filter-panel .controls-row > div:first-child .card::after {\r\n    content: \"\";\r\n    display: block;\r\n    height: 6px;\r\n    pointer-events: none;\r\n}\r\n\r\n/* Custom scrollbar (modern browsers) */\r\n.filter-panel .controls-row > div:first-child .card::-webkit-scrollbar {\r\n    width: 8px;\r\n}\r\n.filter-panel .controls-row > div:first-child .card::-webkit-scrollbar-thumb {\r\n    background: rgba(0,0,0,0.08);\r\n    border-radius: 8px;\r\n}\r\n.filter-panel .controls-row > div:first-child .card::-webkit-scrollbar-track {\r\n    background: transparent;\r\n}\r\n\r\n/* Points row sits on its own line and its child takes full width */\r\n.filter-panel .points-row {\r\n    margin-top: 0.5rem;\r\n}\r\n.filter-panel .points-row > div {\r\n    width: 100%;\r\n}\r\n\r\n/* Ensure category dropdown button text is left-aligned while keeping the caret at the right */\r\n.filter-panel .controls-row > div:first-child .filterCollapseButton {\r\n    justify-content: flex-start;\r\n    text-align: left;\r\n}\r\n\r\n.filter-panel .controls-row > div:first-child .filterCollapseButton > *:last-child {\r\n    margin-left: auto;\r\n}\r\n\r\n/* Prevent the category button content from wrapping and show ellipses */\r\n.filter-panel .controls-row > div:first-child .filterCollapseButton > div {\r\n    flex: 1 1 0;\r\n    min-width: 0;              /* allow flex child to shrink */\r\n    overflow: hidden;\r\n    white-space: nowrap;       /* prevent wrapping */\r\n    text-overflow: ellipsis;   /* show \"...\" when truncated */\r\n    display: block;\r\n    text-align: left;\r\n}\r\n\r\n/* Ensure the caret stays pinned to the right and doesn't get pushed or centered */\r\n.filter-panel .controls-row > div:first-child .filterCollapseButton > *:last-child {\r\n    margin-left: auto;\r\n    flex: 0 0 auto;\r\n}\r\n\r\n/* Ensure dropdown list items remain left-aligned when their label text wraps */\r\n.filter-panel .card .form-check-label {\r\n    display: inline-flex;\r\n    justify-content: flex-start; /* keep swatch + text left-aligned */\r\n    align-items: center;\r\n    text-align: left;\r\n}\r\n\r\n/* Allow the label text to wrap if needed but keep it left-aligned and ensure it can shrink */\r\n.filter-panel .card .form-check-label > span:last-child {\r\n    flex: 1 1 0;\r\n    min-width: 0;\r\n    white-space: normal;         /* allow wrapping inside list item */\r\n    overflow-wrap: anywhere;     /* safer breaks for long words/URLs */\r\n    word-break: break-word;\r\n    text-align: left;\r\n}\r\n\r\n/* Give the swatch a small right gap so wrapped text doesn't touch it */\r\n.filter-panel .card .color-swatch {\r\n    margin-right: 0.5rem;\r\n}\r\n\r\n/* Responsive: stack controls on narrow screens */\r\n@media (max-width: 576px) {\r\n    .filter-panel .controls-row {\r\n        flex-wrap: wrap;\r\n        gap: 0.5rem;\r\n    }\r\n\r\n    .filter-panel .controls-row > div:first-child,\r\n    .filter-panel .controls-row > div:nth-child(2),\r\n    .filter-panel .controls-row > div:nth-child(3) {\r\n        flex: 1 1 100%;\r\n    }\r\n\r\n    .filter-panel .controls-row > div:first-child .card {\r\n        width: 100%;\r\n        left: 0;\r\n        top: calc(100% + 0.25rem);\r\n    }\r\n}\r\n\r\n/* Visible points list entry styles: colored swatch, left-aligned text, emphasized name */\r\n.filter-panel .points-row .card {\r\n    padding: 0.5rem;\r\n    max-height: 300px;\r\n    overflow: auto;\r\n}\r\n\r\n/* Each entry row */\r\n.filter-panel .points-row .card > div {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    padding: 0.4rem 0.45rem;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    transition: background-color 120ms ease;\r\n}\r\n\r\n/* Hover / active affordance */\r\n.filter-panel .points-row .card > div:hover {\r\n    background-color: rgba(0,0,0,0.03);\r\n}\r\n\r\n/* Left color swatch (the first span in each entry) */\r\n.filter-panel .points-row .card > div > span:first-child {\r\n    width: 14px;\r\n    height: 14px;\r\n    border-radius: 4px;\r\n    border: 1px solid #e6e6e6;\r\n    flex: 0 0 14px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n/* Text container: ensure it can shrink and keep text left-aligned */\r\n.filter-panel .points-row .card > div > div {\r\n    min-width: 0;\r\n    width: 100%;\r\n    overflow: hidden;\r\n}\r\n\r\n/* Inner text layout: place name and address on the same row */\r\n.filter-panel .points-row .card > div > div > div {\r\n    display: flex;\r\n    flex-direction: row;        /* place name + address on one line */\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    min-width: 0;\r\n}\r\n\r\n/* Emphasized name: bold, keep its natural width, truncate if too long */\r\n.filter-panel .points-row .card > div > div > div > span:first-child {\r\n    font-weight: 600;\r\n    line-height: 1;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: inline-block;\r\n    flex: 0 0 auto;            /* don't let the name collapse; keep intrinsic size */\r\n    max-width: 40%;            /* prevent name from taking all space (tweak as needed) */\r\n    text-align: left;\r\n}\r\n\r\n/* Address / secondary text: take remaining space, left-aligned and truncated */\r\n.filter-panel .points-row .card > div > div > div > span:last-child {\r\n    color: #6c757d;\r\n    font-size: 0.9rem;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: block;\r\n    flex: 1 1 0;               /* fill remaining space and truncate */\r\n    min-width: 0;              /* allow truncation inside flex */\r\n    text-align: left;\r\n}\r\n\r\n/* Make sure overall card entries remain left_aligned on small screens too */\r\n@media (max-width: 576px) {\r\n    .filter-panel .points-row .card > div > div > div > span:first-child,\r\n    .filter-panel .points-row .card > div > div > div > span:last-child {\r\n        white-space: nowrap;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
